import React from 'react';
import SuperAuthBox from './SuperAuthBox';
import SafetyAuthBox from './SafetyAuthBox';
import FactoryAuthBox from './FactoryAuthBox';
import { AuthListContainer } from './AuthList.css';

const AuthListMain = ({ auths, selectAuth, setSelectAuth }) => {
  return (
    <AuthListContainer>
      <SuperAuthBox auths={auths.filter((auth) => auth.level === 1)} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />
      <SafetyAuthBox auths={auths.filter((auth) => auth.level === 2)} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />
      <FactoryAuthBox auths={auths.filter((auth) => auth.level === 3 || auth.level === 4)} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />
    </AuthListContainer>
  );
};

export default AuthListMain;
